import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ContentInterpreter from "@/components/ContentInterpreter/ContentInterpreter";
import { hexToRgba } from "@/utils/color";

interface BannerProps {
  subject?: string;
  message?: string;
  subMessage?: string;
  bgColor: string;
  textColor: string;
  onClose?: () => void;
}

const Banner: React.FC<BannerProps> = ({
  subject,
  message,
  subMessage,
  bgColor,
  textColor,
  onClose = () => {},
}) => {
  const [isHovering, setIsHovering] = useState(false);

  const borderColorWithOpacity = textColor.startsWith("#")
    ? hexToRgba(textColor, 0.25)
    : textColor; // fallback for named colors

  const bannerStyle: React.CSSProperties = {
    backgroundColor: bgColor,
    color: textColor,
    padding: "12px 16px",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    position: "relative",
    borderColor: borderColorWithOpacity,
    borderBottom: `1px solid ${borderColorWithOpacity}`,
  };

  const contentContainerStyle: React.CSSProperties = {
    width: "80%",
    maxWidth: "800px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const messageContainerStyle: React.CSSProperties = {
    flex: 1,
    textAlign: "center",
  };

  const closeIconStyle: React.CSSProperties = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    marginLeft: "16px",
    border: `1px solid ${textColor}`,
    backgroundColor: isHovering ? textColor : "transparent",
    color: isHovering ? bgColor : textColor,
    transition: "background-color 0.2s, color 0.2s",
  };

  return (
    <div style={bannerStyle}>
      <div style={contentContainerStyle}>
        <div style={messageContainerStyle}>
          {subject && (
            <div style={{ fontSize: "16px", fontWeight: 700 }}>
              <ContentInterpreter
                text={subject}
                parentTag="span"
                renderAsPTags={false}
                className={`banner-content-${textColor.replace("#", "")}`}
                style={{ color: textColor }}
              />
            </div>
          )}
          {message && (
            <div style={{ fontSize: "16px", fontWeight: 500 }}>
              <ContentInterpreter
                text={message}
                parentTag="span"
                renderAsPTags={false}
                className={`banner-content-${textColor.replace("#", "")}`}
                style={{ color: textColor }}
              />
            </div>
          )}
          {subMessage && (
            <div style={{ fontSize: "13.55px", fontWeight: 500 }}>
              <ContentInterpreter
                text={subMessage}
                parentTag="span"
                renderAsPTags={false}
                className={`banner-content-${textColor.replace("#", "")}`}
                style={{ color: textColor }}
              />
            </div>
          )}
        </div>
        <div
          onClick={onClose}
          style={closeIconStyle}
          title="Close"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    </div>
  );
};

export default Banner;
